export enum OtpDestinationType {
  Telegram = 'telegram',
  Sms = 'sms',
  Email = 'email',
}
